import { type RouteObject } from 'react-router-dom';

import { values } from 'lodash-es';

import { AxiosUserAuthGuard } from '@/axios/hooks/useAxiosTokenEffect';

import { 월별_결제_내역_다운로드_라우터 } from '.';

const cafe24MasterRoutes: RouteObject = {
  async lazy() {
    const { default: Layout } = await import('@/layout/mainLayout');
    return {
      element: (
        <AxiosUserAuthGuard>
          <Layout />
        </AxiosUserAuthGuard>
      ),
    };
  },
  children: [...values(월별_결제_내역_다운로드_라우터)],
};

export default cafe24MasterRoutes;
